import React, { useState } from 'react'
import { Monitor, Smartphone } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'

const EmailPreview = ({ subject, previewText, html, actions }) => {
  const [mode, setMode] = useState('desktop')

  const srcDoc = `<!DOCTYPE html><html><head><meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <style>body{font-family:Arial,Helvetica,sans-serif;margin:0;padding:16px;color:#1f2937;}</style>
    </head><body>${html || '<p style="color:#9ca3af">Nothing to preview yet.</p>'}</body></html>`

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1 border rounded-md p-0.5">
          <Button
            variant={mode === 'desktop' ? 'secondary' : 'ghost'}
            size="icon"
            className="h-7 w-7"
            onClick={() => setMode('desktop')}
          >
            <Monitor className="h-4 w-4" />
          </Button>
          <Button
            variant={mode === 'mobile' ? 'secondary' : 'ghost'}
            size="icon"
            className="h-7 w-7"
            onClick={() => setMode('mobile')}
          >
            <Smartphone className="h-4 w-4" />
          </Button>
        </div>
        {actions}
      </div>

      <div className="rounded-lg border bg-muted/30 p-4 flex justify-center">
        <div className={cn('bg-white rounded shadow-sm overflow-hidden', mode === 'mobile' ? 'w-[390px]' : 'w-full')}>
          <div className="border-b px-4 py-3">
            <p className="text-sm font-medium truncate">{subject || '(No subject)'}</p>
            {previewText && <p className="text-xs text-muted-foreground truncate">{previewText}</p>}
          </div>
          <iframe
            title="Email preview"
            srcDoc={srcDoc}
            sandbox="allow-same-origin"
            className="w-full border-0"
            style={{ height: 500 }}
          />
        </div>
      </div>
    </div>
  )
}

export default EmailPreview
